const carrier = '/';

export enum RouterEnum {
  login = <any>'login',
  home = <any>'home',
  loginCarrier = <any>'authentication/login/carrier',
  loginOwner = <any>'authentication/login/owner',
  termsAndConditions = <any>'authentication/login/terms',
  registration = <any>'authentication/registration',
  regionValidation = <any>'authentication/account/region/registration',
  companyRegistration = <any>'authentication/account/carrier/registration/',
  accountRegistration = <any>'authentication/account/registration',
  loginContractor = <any>'authentication/login/contractor',
  registrationContractor = <any>'authentication/contractor/registration',
  recoverPassword = <any>'authentication/recover-password',
  profile = <any>'home/user/profile',
  driverGrid = <any>'driver/list',
  vehicleGrid = <any>'vehicle/list',
  addVehicle = <any>'vehicle/create',
  priceParameterGrid = <any>'priceParameter/list',
  travelGrid = <any>'travel/dashboard',
  travelReportGrid = <any>'reports/travels-list',
  carrierSurrenderReport = <any>'reports/surrender-report',
  loginAdmin = <any>'authentication/login/admin',
  requestsGrid = <any>'admin/accounts/list',
  clientGrid = <any>'client/list',
  clientEdit = <any>'client/edit',
  clientContractors = <any>'client/contractors',
  confirmPayTravels = <any>'pay/travels/confirm-travels',
  travelsToPay = <any>'pay/travels',
  addCurrentAccount = <any>'current-account/create',
  currentAccountGrid = <any>'client/current-account/list',
  paymentsGrid = <any>(
    'client/current-account/payments/payments-list'
  ),
  settingPaymentsCarrier = <any>'home/admin/accounts/setting-payments-carrier',
  dashboardAdmin = <any>'home/admin/dashboard',
  travelFareGrid = <any>'settings/travel-fare-list',
  travelFare = <any>'settings/travel-fare-create',
  carrierPreferences = <any>'settings/preferences',
  surrenderList = <any>'home/generic/billing/surrender-list',
  surrenderDetailList = <any>'home/generic/billing/surrender-detail-list',
  adminLiquidationDetail = <any>'home/generic/billing/liquidation-detail-list',
  adminLiquidationHistory = <any>'home/generic/billing/liquidation-history/',
  liquidationHistory = <any>'home/generic/billing/liquidation-list',
  driver = <any>'driver/create',
  driverEdit = <any>'driver/edit',
  driverCheckingAccountDetails = <any>(
    'checking-accounts/drivers/details'
  ),
  driverCheckingAccount = <any>'checking-accounts/drivers',
  vehicle = <any>'vehicle/create',
  dashboardCarrier = <any>'dashboard',
  travelDetail = <any>'travel/detail',
  travelReportDetail = <any>'reports/travels-list/detail',
  advancesList = <any>'pay/drivers/advancements/list/',
  advancesCreate = <any>'pay/drivers/advancements/create',
  passengersList = <any>'travel/passengers/list',
  travelCreate = <any>'travel/create',
  clientCreate = <any>'client/create',
  clientImport = <any>'client/import',
  dashboardContractor = <any>'home/contractor/dashboard',
  addContractor = <any>'home/contractor/users/add',
  editContractor = <any>'home/contractor/users/edit',
  listContractors = <any>'home/contractor/users/list',
  addAdmin = <any>'home/admin/settings/add-admin/create',
  adminList = <any>'home/admin/settings/admin-list/list',
  adminCheckingAccountDetail = <any>'home/admin/checking-accounts/detail/',
  addPermission = <any>'home/admin/settings/permission/add-permission/create',
  permissionList = <any>'home/admin/settings/permission/permission/list',
  ownerList = <any>'owner/list',
  ownerCreate = <any>'owner/create',
  ownerEdit = <any>'owner/edit',
  ownerCheckingAccountDetails = <any>(
    'checking-accounts/owners/details'
  ),
  addCostCenter = <any>'home/contractor/settings/cost-center/add',
  costCenterList = <any>'home/contractor/settings/cost-center/list',
  addSettlement = <any>'settlement-create',
  settlementList = <any>'settlement-list',
  costCenterEdit = <any>'home/contractor/settings/cost-center/edit',
  adminParametersEditor = <any>'home/admin/settings/parameters/editor',
  adminParametersList = <any>'home/admin/settings/parameters',
  vehicleTypeList = <any>'home/admin/settings/vehicleType/list',
  vehicleTypeCreate = <any>'home/admin/settings/vehicleType/add',
  vehicleTypeEdit = <any>'home/admin/settings/vehicleType/edit',
  listDriverOnline = <any>'driver/list/Assign',
  createSurrender = <any>'home/admin/billing/surrender-create',
  currencyGrid = <any>'home/admin/currencies',
  contractorAreaList = <any>'home/contractor/areas/list',
  addContractorArea = <any>'home/contractor/areas/add',
  editContractorArea = <any>'home/contractor/areas/edit',
  importContractorAreas = <any>'home/contractor/areas/import',
  contractorEmployeeList = <any>'home/contractor/employees/list',
  importEmployeeList = <any>'home/contractor/employees/import',
  contractorListTravels = <any>'home/contractor/travel/listed',
  contractorCreateTravel = <any>'home/contractor/travel/create',
  contractorTravelDetail = <any>'home/contractor/travel/detail',
  contractorSettlements = <any>'settlements/contractor',
  // contractorLiquidationDetail = <any> 'contractor-settlement-create/',
  contractorsLiquidationsList = <any>(
    'liquidations/contractors/list'
  ),
  contractorLiquidationDetail = <any>(
    'liquidations/contractors/details/'
  ),
  passengerLiquidationDetail = <any>(
    'liquidations/passenger/details/'
  ),
  driverLiquidationDetail = <any>'liquidations/drivers/details/',
  ownerLiquidationDetail = <any>'liquidations/owners/details/',
  contractorLastLiquidation = <any>(
    'liquidations/contractors/last-liquidation/'
  ),
  passengerLiquidationList = <any>'liquidations/passenger/list',
  driverLiquidationList = <any>'liquidations/drivers/list',
  driverLiquidationCreate = <any>'liquidations/drivers/create/',
  driverLastLiquidation = <any>(
    'liquidations/drivers/last-liquidation/'
  ),
  ownerLastLiquidation = <any>(
    'liquidations/owners/last-liquidation/'
  ),
  driverLiquidationHistory = <any>'liquidations/drivers/history/',
  ownersLiquidationHistory = <any>'liquidations/owners/history/',
  ownerLiquidationList = <any>'liquidations/owners/list',
  ownerLiquidationCreate = <any>'liquidations/owners/create/',
  passengerLiquidationCreate = <any>(
    'liquidations/passenger/create/'
  ),
  passengerLastLiquidation = <any>(
    'home/carrier/liquidations/passenger/last-liquidation/'
  ),
  passengerLiquidationHistory = <any>'home/carrier/liquidations/passenger/history/',
  carrierLiquidationDetail = <any>(
    'home/contractor/management/liquidations/contractors/detail/'
  ),
  carrierLiquidationHistory = <any>(
    'home/contractor/management/liquidations/contractors/history/'
  ),
  contractorLiquidationCreate = <any>(
    'liquidations/contractors/create/'
  ),
  contractorLiquidationHistory = <any>(
    'liquidations/contractors/history/'
  ),
  checkingAccountDetail = <any>(
    'client/:contractorId/current-account/detail/'
  ),
  carrierCheckingAccountDetail = <any>(
    'home/contractor/management/current-account/detail/'
  ),
  carrierAppStore = <any>'integrations/list',
  contractorEdit = <any>'client/contractors/edit',
  contractorImport = <any>'client/contractors/import',
  clientCheckingAccountDetail = carrier+'checking-accounts/clients/detail',
  carrierLiquidationList = <any>'/home/contractor/management/settlement-list',
  carrierIntegrationsList = <any>'settings/integrations/list',
  carrierViewIntegration = <any>'settings/integrations/view',
  contractorIntegrationsList = <any>(
    'home/contractor/settings/integrations/list'
  ),
  contractorViewIntegration = <any>'home/contractor/settings/integrations/view',

  adminCarrierIntegrationsList = <any>(
    'home/admin/settings/integrations/carrier-list'
  ),
  adminContractorrIntegrationsList = <any>(
    'home/admin/settings/integrations/contractor-list'
  ),

  adminCarrierIntegrationsListView = <any>(
    'home/admin/settings/integrations/carrier-view'
  ),
  adminContractorrIntegrationsListView = <any>(
    'home/admin/settings/integrations/contractor-view'
  ),
  mailchimpIntegration = <any>'integrations/mailchimp',
  csvIntegration = <any>'integrations/csv',
  ivrIntegration = <any>'integrations/ivr',
  pluginWebReservation = <any>'integrations/plugin-web-reservation',
  contractorCostCenterReport = <any>(
    'home/contractor/reports/cost-center-report'
  ),
  costCenterRerportsCarrier = <any>'reports/cost-center-report',
  cashFlow = <any>'reports/cash-flow',
  whatsappIntegration = <any>'integrations/whatsapp',
  signalIntegration = <any>'integrations/signal',
  AffiLiquidationDetail = <any>'affiliate/liquidation-detail',
  AffiCheckingAccountDetail = <any>(
    'affiliate/checking-account-detail/'
  ),
  AffiCheckingAccount = <any>'affiliate/checking-account',
  ownerLiquidationDetailForOwnerModule = <any>'home/owner/reports/details/',
  ownerCheckingAccount = <any>'home/owner/admin/checking-accounts',
  dashboardOwner = <any>'home/owner/dashboard',
  travelDetailOwner = <any>'home/owner/reports/travel-detail',
  AffiliateRequest = <any>'/affiliate/request',
  AffiliateOffering = <any>'/affiliate/offering',
  affiOneShotQuote = <any>(
    '/carrier/affiliate/oneshot-quote-counteroffer/'
  ),
  oneShotRequest = <any>'/affiliate/oneshot-request',
  OneshotAgreementsRequested = <any>(
    '/affiliate/os-agreement-requested'
  ),
  profileAffiATC = <any>'/affiliate/atc-profile',
  ownerPlatformNotAllowed = <any>'home/owner/platform-not-allowed',
  farmOut = <any>'/gnet/farm-out',
  farmOutRequest = <any>'/gnet/farm-out/request',
  farmIn = <any>'/gnet/farm-in',
  quotes = <any>'/travel/quotes',
  creditAccounts = <any>'/gnet/credit-accounts',
  creditAccountDetail = <any>'/gnet/credit-accounts/detail/',
  newServicesTypes = <any>'home/admin/settings/vehicleType/new'
}
